// Phone number validation.
//
// The rule is Indian-mobile-first, because that is what every form here asks
// for: ten digits starting 6-9, with an optional +91 / 91 / 0 prefix and any
// mix of spaces, dashes, dots or brackets. An explicitly international number
// (+ followed by a non-91 country code) is accepted on E.164 length alone, so
// an employee's overseas emergency contact is not locked out of a form they
// must complete in one sitting.
//
// Keep in step with backend/utils/phone.js.

/** Strip the separators people type; keeps a leading + and the digits. */
export const cleanPhone = (value) =>
  String(value ?? "")
    .trim()
    .replace(/[\s\-().]/g, "");

export const isValidPhone = (value) => {
  const cleaned = cleanPhone(value);
  if (!/^\+?\d+$/.test(cleaned)) return false;

  const digits = cleaned.replace(/^\+/, "");

  // Foreign number, explicitly dialled: trust the E.164 length range.
  if (cleaned.startsWith("+") && !digits.startsWith("91")) {
    return digits.length >= 8 && digits.length <= 15;
  }

  // Drop an Indian country code or trunk prefix, but only when the length says
  // it really is one — "9198765432" is a valid 10-digit number, not 91 + 8.
  let local = digits;
  if (local.length === 12 && local.startsWith("91")) local = local.slice(2);
  else if (local.length === 11 && local.startsWith("0")) local = local.slice(1);

  return /^[6-9]\d{9}$/.test(local);
};

/** Characters worth keeping while someone is still typing. */
export const sanitizePhoneInput = (value) =>
  String(value ?? "")
    .replace(/[^\d+\s-]/g, "")
    .slice(0, 18);
